import updateLocalStorage from '@/utils/updateLocalStorage';

const setCompsetsUpdatedFlag = (val) => {
  updateLocalStorage('compsetsUpdated', !!val);
};

export default setCompsetsUpdatedFlag;
